import * as Sentry from "@sentry/react";
import ReactDOM from 'react-dom/client';
import App from './App';
import Header from './components/Header';
import Menu from './components/Menu';
import Footer from './components/Footer';
import LoginPage from './pages/LoginPage';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import React, { Fragment } from 'react';
import './styles/MenuStyles.css';

// CACHES
import CacheBuster from 'react-cache-buster';
import { Provider } from 'react-redux'

import generateStore from './Redux/store'
import axios from 'axios';
import Cookies from 'universal-cookie';

// Interceptor global: adjunta el JWT (cookie 'token') a TODA petición axios dirigida a la API propia.
// Centraliza la autenticación para que la fallback policy del backend no rechace llamadas a las que
// se les olvidó el header Authorization. No toca hosts externos (evita filtrar el token).
axios.interceptors.request.use((config) => {
    try {
        const apiHost = window.API_URL || '';
        const url = config.url || '';
        if (apiHost && url.startsWith(apiHost) && !(config.headers && config.headers.Authorization)) {
            const token = new Cookies().get('token');
            if (token) {
                config.headers = config.headers || {};
                config.headers.Authorization = `Bearer ${token}`;
            }
        }
    } catch (e) {
        // nunca bloquear la petición por un fallo del interceptor
    }
    return config;
});

Sentry.init({
    dsn: window.APP_SENTRY_CONFIG?.DSN,
    sendDefaultPii: true,
    integrations: [
        Sentry.browserTracingIntegration(),
        Sentry.replayIntegration()
    ],
    environment: window.APP_SENTRY_CONFIG?.ENVIRONMENT || "development",
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    tracePropagationTargets: window.APP_SENTRY_CONFIG?.API_URLS || ["localhost"],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    enableLogs: true
});

const root = ReactDOM.createRoot(document.getElementById('root'));

const store = generateStore()

root.render(
    <CacheBuster
        currentVersion={"0.9.5.3"}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={true} //If true, the library writes verbose logs to console.
        loadingComponent={alert} //If not pass, nothing appears at the time of new version check.
        metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
    >
        <Provider store={store}>
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<LoginPage />} />
                    <Route path='*' element={
                        <Fragment>
                            <Header />
                            <div className="d-flex align-items-stretch">
                                <Menu />
                                <div style={{ paddingTop: '2rem', display: 'flex', overflowX: 'hidden', width: '100%' }} className="apple-background main-content">
                                    <div className="container-fluid px-lg-0 px-xl-4">
                                        <App />
                                    </div>
                                    <Footer />
                                </div>
                            </div>
                        </Fragment>} />
                </Routes>
            </BrowserRouter>
        </Provider>
    </CacheBuster>
);

